import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Heart, ArrowRight } from 'lucide-react';

/**
 * Compact "Check in" link card. The full Body & Mind check-in lives only on the
 * Dashboard (single daily ritual); Mind & Recovery show this nudge that takes
 * you there instead of duplicating the form.
 */
const CheckinNudge = ({ color = '#CCFF00' }) => {
  const navigate = useNavigate();
  return (
    <button
      onClick={() => navigate('/dashboard')}
      data-testid="checkin-nudge"
      className="w-full hpme-card p-4 flex items-center gap-3 text-left hover:border-white/25 transition-colors active:scale-[0.99]"
    >
      <span className="w-9 h-9 rounded-full grid place-items-center shrink-0" style={{ background: `${color}1a`, border: `1px solid ${color}55` }}>
        <Heart className="w-4 h-4" style={{ color }} />
      </span>
      <span className="flex-1 min-w-0">
        <span className="block font-secondary font-bold text-sm text-white">Daily check-in</span>
        <span className="block text-xs text-zinc-400 leading-snug">Log how you feel — it tunes today&apos;s Mind &amp; Recovery reads.</span>
      </span>
      <ArrowRight className="w-4 h-4 text-zinc-500 shrink-0" />
    </button>
  );
};

export default CheckinNudge;
